import { useMutation, useQueryClient } from "@tanstack/react-query";
import { saveTheme } from "../api";
import { themesKeys } from "../queries/index";
import type { ThemeFormValues } from "../../types";

export const useSaveThemeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: ThemeFormValues) => {
      const response = await saveTheme(data);
      return response.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.removeQueries({ queryKey: themesKeys.all });
      if (variables.id) {
        queryClient.removeQueries({ queryKey: themesKeys.detail(variables.id) });
      }
    },
  });
};
